import coverImg from "assets/images/v139/cover.webp"

export const v139Config = {
  cover: {
    en: coverImg,
  },
}
